import styled from "styled-components";
import "../../styles/variables.css";

export const OverlapLogosContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: relative;
  img {
    z-index: 1;
  }
`;

export const TopImage = styled.img`
  z-index: 2 !important;
  margin-right: -20px;
`;
